// extracted by mini-css-extract-plugin
export default {"Playground":"PlaygroundC7DInM9NFvBg","Playground-section":"Playground-section3VTXuaYZivJK","Playground-section_sticky":"Playground-section_sticky_fBLN0qIkmEd"};